import { DEFAULT_CURRENCY, moneyFormat } from "@redotech/money/util";
import {
  AdjustmentAmountOption,
  Condition,
} from "@redotech/redo-model/return-flow/condition";
import {
  adjustmentAmountFromModel,
  validateAdjustmentAmountCondition,
  type AdjustmentAmountState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const ADJUSTMENT_AMOUNT = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<AdjustmentAmountState>
  >,
): ConditionType<AdjustmentAmountState, Condition.AdjustmentAmount> => ({
  name: "Total adjustment amount",
  description(state) {
    return `Adjustment amount ${state.adjustmentAmountOption.toLowerCase()} ${moneyFormat(
      { amount: +state.adjustmentAmount, currency: DEFAULT_CURRENCY },
    )}`;
  },
  Details(props: ConditionTypeDetailsProps<AdjustmentAmountState>) {
    return React.createElement(Details, props);
  },
  empty: {
    adjustmentAmountOption: AdjustmentAmountOption.EQUALS,
    adjustmentAmount: (0).toFixed(2),
  },
  fromModel(model) {
    return adjustmentAmountFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.ADJUSTMENT_AMOUNT,
      adjustmentAmountOption: state.adjustmentAmountOption,
      adjustmentAmount: +state.adjustmentAmount,
    };
  },
  valid(state) {
    return validateAdjustmentAmountCondition(state).valid;
  },
});

export { type AdjustmentAmountState } from "@redotech/redo-model/return-flow/condition-validate";
